import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';
import theme from '../../theme';
import { SxStyles } from '../../types';
import { getResponsiveSize, tabletRatio } from '../../utils';

export const networkReportPopoverStyles: SxStyles = {
  popper: {
    zIndex: 1299,
  },
  paper: {
    boxSizing: 'border-box',
    p: getResponsiveSize(24),
    borderRadius: getResponsiveSize(12),
    border: `1px solid ${theme.palette.neutral?.grey20}`,
    [theme.breakpoints.media?.laptop!]: {},
    [theme.breakpoints.media?.tablet!]: {
      p: getResponsiveSize(10, tabletRatio),
      borderRadius: getResponsiveSize(10, tabletRatio),
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '60vh',
  },
  scrollArea: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    paddingRight: getResponsiveSize(6),
    [theme.breakpoints.media?.tablet!]: {
      paddingRight: getResponsiveSize(4, tabletRatio),
    },
  },
  contentStack: {
    gap: getResponsiveSize(10),
    [theme.breakpoints.media?.tablet!]: {
      gap: getResponsiveSize(8, tabletRatio),
    },
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    gap: getResponsiveSize(8),
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    gap: getResponsiveSize(8),
    minWidth: 0,
    alignItems: 'center',
    flexShrink: 1,
  },
  connectionTitle: {
    fontWeight: 700,
    whiteSpace: 'nowrap',
  },
  closeButton: {
    width: getResponsiveSize(28),
    height: getResponsiveSize(28),
    p: 0,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: theme.palette.myPrimary?.lightBlue100,
    flexShrink: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.myPrimary?.lightBlue70,
    },
    '&:active': {
      backgroundColor: 'transparent',
      color: theme.palette.myPrimary?.lightBlue70,
    },
    '& .MuiTouchRipple-root': {
      borderRadius: '50%',
    },
    [theme.breakpoints.media?.tablet!]: {
      width: getResponsiveSize(24, tabletRatio),
      height: getResponsiveSize(24, tabletRatio),
    },
  },
  impactText: {
    color: theme.palette.neutral?.grey70,
  },
  quickFixTitle: {
    fontWeight: 700,
  },
  quickFixList: {
    mt: getResponsiveSize(4),
    mb: 0,
    pl: getResponsiveSize(16),
    listStyleType: 'disc',
    color: theme.palette.neutral?.grey70,
  },
  quickFixItem: {
    color: theme.palette.neutral?.grey70,
  },
  quickFixText: {
    color: theme.palette.neutral?.grey70,
    fontSize: theme.typography.subtitle1,
  },
  technicalInfoFooter: {
    marginTop: getResponsiveSize(10),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    textAlign: 'right',
    gap: getResponsiveSize(2),
    flexShrink: 0,
  },
  technicalInfoLabel: {
    color: theme.palette.neutral?.grey30,
    fontSize: theme.typography.fs12,
    lineHeight: getResponsiveSize(14),
  },
  technicalInfoText: {
    color: theme.palette.neutral?.grey30,
    fontSize: theme.typography.fs12,
    lineHeight: getResponsiveSize(14),
  },
};

export const statusDotStyle = (statusColor: string): SxProps<Theme> => ({
  width: getResponsiveSize(10),
  height: getResponsiveSize(10),
  borderRadius: '50%',
  bgcolor: statusColor,
  border: `1px solid ${theme.palette.neutral?.grey30}`,
});
